export default class BadRequestException extends Error {
  constructor(code, message) {
    super(message);
    this.code = code;
  }
}
